/** Textos da barra de navegação. */
const pt = {
    "nav.home": "Home",
    "nav.servers": "Servidores",
    "nav.vips": "VIPs",
    "nav.kits": "Kits",
    "nav.shop": "Loja",
    "nav.discord": "Discord",
    "nav.logoAria": "ZRS — início",
    "nav.account": "Conta",
    "nav.accountArea": "Área da conta",
    "nav.signOut": "Sair",
    "nav.login": "Login",
    "nav.joinDiscord": "Entrar no Discord",
    "nav.menu": "Menu",
};
const en = {
    "nav.home": "Home",
    "nav.servers": "Servers",
    "nav.vips": "VIPs",
    "nav.kits": "Kits",
    "nav.shop": "Shop",
    "nav.discord": "Discord",
    "nav.logoAria": "ZRS — home",
    "nav.account": "Account",
    "nav.accountArea": "Account area",
    "nav.signOut": "Sign out",
    "nav.login": "Login",
    "nav.joinDiscord": "Join Discord",
    "nav.menu": "Menu",
};

export default { pt, en };
